import { useNavigate } from 'react-router-dom';
import guideHtml from './guide.html?raw';

/**
 * The driver guide, behind the login.
 *
 * It used to be a static file at /guide.html, which nginx served to anyone who
 * knew the URL — and it was linked from the sign-in screen, so anyone at all.
 * The guide explains how the verification works and gives the exact distance
 * the geofence allows; that is not information to hand to the internet.
 *
 * The document is bundled as a string and rendered in an iframe. Not injected
 * into the page: its stylesheet targets bare `header`, `ol`, `li` and `footer`,
 * and those rules would escape and restyle the whole app. srcdoc gives complete
 * isolation for one line of code.
 */
export function GuideScreen() {
  const navigate = useNavigate();

  return (
    <main className="screen guide-screen">
      <button className="btn link" onClick={() => navigate(-1)}>&larr; Back</button>
      <iframe
        title="How to use the app"
        srcDoc={guideHtml}
        className="guide-frame"
        // No script runs in it, and it may not navigate anything away.
        sandbox=""
      />
    </main>
  );
}
